<ng-template #templateModalForm role="document" let-modal>

  <app-page-comp-header
    [label0Show]="label0Text != undefined && !hideSubject"
    [label0Text]="label0Text"
    [showBottomBorder]="false"
    [title]="title != undefined ? title : formTitle">
  </app-page-comp-header>

  <div class="row">
    <div [className]="embeddedFormMode ? 'col-3' : 'col-0'"></div>
    <div [className]="embeddedFormMode ? 'col-6' : 'col-0'">

    <form [formGroup]="templateForm" class="tablelist-form" autocomplete="off">
      <div class="modal-body">

        @if (!this.onlyShowBody) {
          @if(!this.hideMessageType) {
          <div class="mb-3 d-flex align-items-center gap-2">
            <label class="form-label fw-semibold mb-0 required">Message Type</label>
            <span class="text-muted font-normal">{{ messageType }}</span>
          </div>
          }

          <!-- Template Name -->
          <div class="mb-3">
            <label class="form-label fw-semibold required">Template Name</label>
            <input autocomplete="no-fill" type="text" id="templateName-field" class="form-control" placeholder="" formControlName="templateName" data-lpignore="true" [ngClass]="{ 'is-invalid': templateFormSubmitted && formData['templateName'].errors }" />
          </div>

          @if (genericComposeMode) {
            <div class="mb-3">
              <label for="communicationTypeId-field" class="form-label fw-semibold">Communication Type</label>
              <select class="form-select" id="communicationTypeId-field" formControlName="communicationTypeId">
                <option [ngValue]="undefined"></option>
                @for (object of communicationTypeIdData; track object.id) {
                  <option [ngValue]="object.id">{{object.description}}</option>
                }
              </select>
            </div>
          }

          @if (!hideSubject) {
            <!-- Subject -->
            <div class="mb-3" (click)="handleMouseClick($event)" (keyup)="handleKeyUp($event)">
              <label for="subject-field" class="form-label fw-semibold required">
                Subject
                <i
                  title="To insert a system value, type @@ or hold the Ctrl key down and click where you want to place it."
                  class="bi bi-info-circle text-secondary ms-1"
                  style="cursor: pointer;">
                </i>
              </label>
              <input autocomplete="no-fill" type="text" #subjectTextArea id="subject-field" class="form-control" placeholder="" formControlName="subject" data-lpignore="true" [ngClass]="{ 'is-invalid': (templateFormSubmitted && formData['subject'].errors) || (this.getDodgySystemPlaceHolders(formData['subject'].value) != '') }" />
              <div class="invalid-feedback">Unknown system value(s) found - {{this.getDodgySystemPlaceHolders(formData['subject'].value)}}</div>
            </div>
          }

          @if (!genericComposeMode) {

            @if(!this.hideFromOptions) {
              <!-- From Email -->
              <div class="mb-3">
                <div [ngClass]="{ 'is-invalid': templateFormSubmitted && ((formData['fromEmail'].value == null || formData['fromEmail'].value == '') &&
                                                                           (formData['useDefaultFromEmail'].value == null || formData['useDefaultFromEmail'].value == false ||
                                                                            this.companyDefaults.fromEmail == null || this.companyDefaults.fromEmail == '')) }">
                  <label class="form-label fw-semibold required">From Email Address</label>
                  <input autocomplete="no-fill" type="text" id="fromEmail-field" class="form-control" placeholder="" formControlName="fromEmail" data-lpignore="true" [ngClass]="{ 'is-invalid': templateFormSubmitted && formData['fromEmail'].errors }" />
                  @if(formData['fromEmail'].hasError('maxlength')) {
                    <div class="invalid-feedback">Maximum length of {{fromEmailMaxLength}} characters has been exceeded</div>
                  } @else if (formData['fromEmail'].hasError('invalidEmail')) {
                    <div class="invalid-feedback">Please enter a valid email address</div>
                  }
                  <div class="d-flex align-items-center gap-2 mt-2">
                    <input type="checkbox" class="form-check-input" formControlName="useDefaultFromEmail" (change)="onDefaultFromEmailChange()"/>
                    <span class="text-muted small">Use Default -</span>
                    @if(this.companyDefaults.fromEmail == undefined || this.companyDefaults.fromEmail.trim() == "") {
                      <span class="small text-danger">Default Not Set</span>
                    } @else {
                      <span class="small text-success">{{this.companyDefaults.fromEmail}}</span>
                    }
                    <a href="javascript:void(0);" class="text-primary ms-1" id="editfromemaildefault-btn" (click)="editFromEmailDefault()">
                      <i class="ri-pencil-fill fs-14"></i>
                    </a>
                  </div>
                </div>
                <div class="invalid-feedback">Either a from email address needs to be entered or the use default value needs to be selected.</div>
              </div>
            }
  
            <!-- Recipients -->
            <div class="mb-3 border rounded p-3" style="background-color: var(--vz-light, #f8f9fa);">
  
              <!-- Send To User -->
              <div class="d-flex align-items-center justify-content-between">
                <label class="form-check-label fw-semibold mb-0" for="sendToUser-field">Send To User</label>
                <div class="form-check form-switch form-switch-md mb-0">
                  <input class="form-check-input" type="checkbox" role="switch" id="sendToUser-field" formControlName="sendToUser" (change)="onSendToUserChange()">
                </div>
              </div>
  
              <hr class="my-2">
  
              <!-- Send Elsewhere -->
              <div [ngClass]="{ 'is-invalid': (formData['sendToUser'].value == false) && (formData['sendElsewhere'].value == false) }">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <div class="d-flex align-items-center gap-1">
                    <label class="form-check-label fw-semibold mb-0" for="sendElsewhere-field">Send Elsewhere Email Address</label>
                    <i
                      title="To specifiy more than one destination email address, seperate each email address with a semicolon."
                      class="bi bi-info-circle text-secondary ms-1"
                      style="cursor: pointer;">
                    </i>
                  </div>
                  <div class="form-check form-switch form-switch-md mb-0">
                    <input class="form-check-input" type="checkbox" role="switch" id="sendElsewhere-field" formControlName="sendElsewhere" (change)="onSendElsewhereChange()">
                  </div>
                </div>
  
                <div [ngClass]="{ 'is-invalid': (templateFormSubmitted || this.showElsewhereMessage) && (formData['sendElsewhere'].value == true) &&
                                                ((formData['toEmail'].value == null || formData['toEmail'].value == '') &&
                                                 (formData['useDefaultToEmail'].value == null || formData['useDefaultToEmail'].value == false ||
                                                  this.companyDefaults.toEmail == null || this.companyDefaults.toEmail == '')) }">
                  <input autocomplete="no-fill" type="text" [readonly]="!formData['sendElsewhere'].value" id="toEmail-field" class="form-control" placeholder="" formControlName="toEmail" data-lpignore="true" [ngClass]="{ 'is-invalid': templateFormSubmitted && formData['toEmail'].errors }"/>
                  @if(formData['toEmail'].hasError('maxlength')) {
                    <div class="invalid-feedback">Maximum length of {{toEmailMaxLength}} characters has been exceeded</div>
                  } @else if (formData['toEmail'].hasError('invalidEmail')) {
                    <div class="invalid-feedback">Please enter a valid email address</div>
                  }
                  <div class="d-flex align-items-center gap-2 mt-2">
                    <input type="checkbox" [readonly]="!formData['sendElsewhere'].value" class="form-check-input" formControlName="useDefaultToEmail" (change)="onDefaultToEmailChange()"/>
                    <span class="small" [ngClass]="{ 'disabled-class': !formData['sendElsewhere'].value }">Use Default -</span>
                    @if(this.companyDefaults.toEmail == undefined || this.companyDefaults.toEmail.trim() == "") {
                      <span class="small" [ngClass]="{ 'disabled-class': !formData['sendElsewhere'].value, 'text-danger': formData['sendElsewhere'].value }">Default Not Set</span>
                    } @else {
                      <span class="small" [ngClass]="{ 'disabled-class': !formData['sendElsewhere'].value, 'text-success': formData['sendElsewhere'].value }">{{this.companyDefaults.toEmail}}</span>
                    }
                    <a href="javascript:void(0);" class="text-primary ms-1" id="editsendelsewheredefault-btn" (click)="editSendElsewhereDefault()">
                      <i class="ri-pencil-fill fs-14"></i>
                    </a>
                  </div>
                </div>
                @if(formData['useDefaultToEmail'].value != null && formData['useDefaultToEmail'].value == true && (this.companyDefaults.toEmail == null || this.companyDefaults.toEmail == '')) {
                  <div class="invalid-feedback">Default value needs to be set.</div>
                } @else {
                  <div class="invalid-feedback">Either a send elsewhere email address needs to be entered or the use default value needs to be selected.</div>
                }
              </div>
              <div class="invalid-feedback">At least one of send to user or send elsewhere need to be enabled.</div>
  
            </div>
  
            <!-- CC -->
            <div class="mb-3">
              <label class="form-label fw-semibold">CC</label>
              <input autocomplete="no-fill" type="text" id="cc-field" class="form-control" placeholder="" formControlName="cc" data-lpignore="true" [ngClass]="{ 'is-invalid': templateFormSubmitted && formData['cc'].errors }" />
              @if(formData['cc'].hasError('maxlength')) {
                <div class="invalid-feedback">Maximum length of {{ccMaxLength}} characters has been exceeded</div>
              } @else if (formData['cc'].hasError('invalidEmail')) {
                <div class="invalid-feedback">Please enter a valid email address</div>
              }
              <div class="d-flex align-items-center gap-2 mt-2">
                <input type="checkbox" class="form-check-input" formControlName="useDefaultCC" (change)="onDefaultCCChange()"/>
                <span class="text-muted small">Use Default -</span>
                @if(this.companyDefaults.cc == undefined || this.companyDefaults.cc.trim() == "") {
                  <span class="small text-danger">Default Not Set</span>
                } @else {
                  <span class="small text-success">{{this.companyDefaults.cc}}</span>
                }
                <a href="javascript:void(0);" class="text-primary ms-1" id="editccdefault-btn" (click)="editCCDefault()">
                  <i class="ri-pencil-fill fs-14"></i>
                </a>
              </div>
            </div>
  
            <!-- BCC -->
            <div class="mb-3">
              <label class="form-label fw-semibold">BCC</label>
              <input autocomplete="no-fill" type="text" id="bcc-field" class="form-control" placeholder="" formControlName="bcc" data-lpignore="true" [ngClass]="{ 'is-invalid': templateFormSubmitted && formData['bcc'].errors }" />
              @if(formData['bcc'].hasError('maxlength')) {
                <div class="invalid-feedback">Maximum length of {{bccMaxLength}} characters has been exceeded</div>
              } @else if (formData['bcc'].hasError('invalidEmail')) {
                <div class="invalid-feedback">Please enter a valid email address</div>
              }
              <div class="d-flex align-items-center gap-2 mt-2">
                <input type="checkbox" class="form-check-input" formControlName="useDefaultBCC" (change)="onDefaultBCCChange()"/>
                <span class="text-muted small">Use Default -</span>
                @if(this.companyDefaults.bcc == undefined || this.companyDefaults.bcc.trim() == "") {
                  <span class="small text-danger">Default Not Set</span>
                } @else {
                  <span class="small text-success">{{this.companyDefaults.bcc}}</span>
                }
                <a href="javascript:void(0);" class="text-primary ms-1" id="editbccdefault-btn" (click)="editBCCDefault()">
                  <i class="ri-pencil-fill fs-14"></i>
                </a>
              </div>
            </div>
          }
        }

        <!-- Message -->
        <div class="mb-3" (click)="handleMouseClick($event)" (keyup)="handleKeyUp($event)">
          <label for="desc-field" class="form-label fw-semibold required">
            Message
            <i
              title="To insert a system value, type @@ or hold the Ctrl key down and click where you want to place it."
              class="bi bi-info-circle text-secondary ms-1"
              style="cursor: pointer;">
            </i>
          </label>
          <textarea
            #messageTextArea
            id="desc-field"
            class="form-control resize-none"
            placeholder=""
            formControlName="message"
            data-lpignore="true"
            [ngClass]="{ 'is-invalid': this.getDodgySystemPlaceHolders(formData['message'].value) != '' }"
            rows="6">
          </textarea>
          <div class="invalid-feedback">Unknown system value(s) found - {{this.getDodgySystemPlaceHolders(formData['message'].value)}}</div>
        </div>

        <!-- Buttons -->
        <div class="d-flex justify-content-between align-items-center pt-3 border-top">
          <div>
            <button *ngIf="template.id > 0 && !onlyShowBody" type="button" class="btn btn-success" [disabled]="invalidInputs()" (click)="saveAsNew()">Save As Copy</button>
          </div>
          <div class="hstack gap-2">
            @if(!embeddedFormMode) {
              <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="closeForm(templateModalAction);modal.close('Close click')">Cancel</button>
            }
            <button *ngIf="canEditTemplate" type="button" class="btn btn-success" [disabled]="invalidInputs()" (click)="save()">Save</button>
            @if(!this.hideSaveAndEnable) {
              <button *ngIf="canEditTemplate && !alreadyEnabled" type="button" class="btn btn-success" [disabled]="invalidInputs()" (click)="saveAndEnable()">Save & Enable</button>
            }
          </div>
        </div>

      </div>
    </form>
    </div>
    <div [className]="embeddedFormMode ? 'col-3' : 'col-0'"></div>
  </div>

</ng-template>

<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>

<app-input-modal-form #inputModalForm
  fieldCaption="System Value"
  formTitle="Insert System Value"
  [input0EnforceMultipleEmailValidation]="false"
  [input0Values]="this.templateReplacementsValues"
  (thisFormSaved)="inputModalFormSubmitted($event)"
></app-input-modal-form>
